import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styled from '@emotion/styled';
import { User } from '@auth0/auth0-spa-js';
import StyledToolTips from '../../../utils/tooltip/StyledToolTip';

const StyledLinkContainer = styled.span`
  display: flex;
`;

const StyledLink = styled(NavLink)`
  color: #ffffff;
  text-decoration: none;
  margin: 0 1rem;
`;

const UserLinkProfile = ({ user }: User) => {
  return (
    <StyledLinkContainer>
      <p>Welcome</p>
      <StyledLink to="person">
        <StyledToolTips title="User Profile" enterDelay={100} arrow>
          <p>{user?.name} !</p>
        </StyledToolTips>
      </StyledLink>
    </StyledLinkContainer>
  );
};

export default UserLinkProfile;
